<template>
  <div class="thesis-embellishment-block">
    <Banner :type="activeName" :total="total"/>

    <Breadcrumb />

    <div class="container-block">
      <el-row :gutter="60">
        <el-col :span="5">
          <ul class="menu-block">
            <li @click="activeName = '6'" :class="{active: activeName === '6'}">
              <img src="@/assets/imgs/icon61.png" class="grey"/>
              <img src="@/assets/imgs/icon60.png" class="blue"/>
              <span>提交辅导申请</span>
            </li>
            <li @click="activeName = '5'" :class="{active: activeName === '5'}">
              <img src="@/assets/imgs/icon59.png" class="grey"/>
              <img src="@/assets/imgs/icon58.png" class="blue"/>
              <span>服务流程</span>
            </li>
            <li @click="activeName = '1'" :class="{active: activeName === '1'}">
              <img src="@/assets/imgs/icon30.png" class="grey"/>
              <img src="@/assets/imgs/icon17.png" class="blue"/>
              <span>专业与服务</span>
            </li>
            <li @click="activeName = '2'" :class="{active: activeName === '2'}">
              <img src="@/assets/imgs/icon32.png" class="grey"/>
              <img src="@/assets/imgs/icon11.png" class="blue"/>
              <span>定价与承诺</span>
            </li>
            <!-- <li @click="activeName = '3'" :class="{active: activeName === '3'}">
              <img src="@/assets/imgs/icon28.png" class="grey"/>
              <img src="@/assets/imgs/icon29.png" class="blue"/>
              <span>样例与反馈</span>
            </li>
            <li @click="activeName = '4'" :class="{active: activeName === '4'}">
              <img src="@/assets/imgs/icon31.png" class="grey"/>
              <img src="@/assets/imgs/icon10.png" class="blue"/>
              <span>编辑团队</span>
            </li> -->
          </ul>
        </el-col>
        <el-col :span="19">
          <!--专业与服务1    定价与承诺2    样例与反馈3   编辑团队4   5服务流程  6提交考研辅导需求-->
          <MajorService v-if="activeName === '1'"/>
          <PricePromise v-else-if="activeName === '2'"/>
          <ExamplesFeedback v-else-if="activeName === '3'"/>
          <EditorialTeam v-else-if="activeName === '4'"/>
          <ServiceProcess v-else-if="activeName === '5'"/>
          <!-- <DemandSide v-else-if="activeName === '6'"/> -->
          <PostgraduateGuidance v-else-if="activeName === '6'"/>
        </el-col>
      </el-row>

    </div>

  </div>
</template>

<script>
/**
 * @description 考研辅导
 */
import * as api from '@/api/user'
// import * as commonFunc from '@/utils/common-func'

// 面包屑
import Breadcrumb from '@/components/Breadcrumb'
// banner
import Banner from './banner'
// 专业与服务
import MajorService from './major_service'
// 定价与承诺
import PricePromise from './price_promise'
// 样例与反馈
import ExamplesFeedback from './examples_feedback'
// 编辑团队
import EditorialTeam from './editorial_team'
// 服务流程
import ServiceProcess from './service_process'
// 提交考研辅导需求
// import DemandSide from './demand_side'
import PostgraduateGuidance from '@/views/requirement_submission/postgraduate_guidance'


export default {
  name: 'ThesisEmbellishment',
  components: {
    Breadcrumb,
    Banner,
    MajorService,
    PricePromise,
    ExamplesFeedback,
    EditorialTeam,
    ServiceProcess,
    // DemandSide,
    PostgraduateGuidance
  },
  data() {
    return {
      total: 0, // 订单总量
      activeName: '',// 专业与服务1    定价与承诺2    样例与反馈3   编辑团队4    5服务流程    6提交考研辅导需求
    }
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route() {
      this.activeName = this.$route.query.activeName ? this.$route.query.activeName : '6'
      // 页面路由变动后，滚动条滚动到顶部
      window.scrollTo(0, 0)
    },
  },
  created() {
    this.activeName = this.$route.query.activeName ? this.$route.query.activeName : '6'
    this.getOrderTotal() //获取订单总数
  },
  methods: {
    /**
     * @description 获取订单总数
     */
    getOrderTotal() {
      const _this = this
      const _param = {}
      api
        .orderTotal(_param)
        .then((res) => {
          const _data = res.data
          
          _this.total = _data.order_total || 0
        })
        .catch((err) => {
          console.log(err)
          // _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    /**
     * @description 左菜单点击
     */
    // menuClick(_active) {
    //   this.activeName = _active
    // }

    //     /**
    //  * @description 获取角色列表
    //  */
    // getListByPage() {
    //   const _this = this
    //   _this.tableLoading = true
    //   const _param = {
    //     page: _this.pageparm.page,
    //     size: _this.pageparm.size,
    //     roleName: _this.pageparm.roleName,
    //     orgid: _this.pageparm.orgid
    //   }
    //   api.listByPage(_param)
    //     .then(res => {
    //       const data = res.data
    //       _this.tableLoading = false
    //       _this.listData = data.result
    //       _this.pageparm.total = data.pageTotalCount
    //     })
    //     // .catch(err => {
    //     // })
    // },
  },
}
</script>
<style lang="scss" scoped>
.thesis-embellishment-block {

  > .container-block > .el-row {
    margin-top: 20px;
  }

  .menu-block {
    background: #ffffff;
    margin: 0;
    padding: 30px;
    list-style-type: none;
    padding-bottom: 200px;

    li {
      margin: 0;
      padding: 0;
      list-style-type: none;
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #979797;
      height: 60px;
      border-bottom: 2px solid #edeef2;
      cursor: pointer;
      margin: 0 0 20px 0;

      img {
        height: 30px;
        margin: 0 10px 0 0;
      }

    }

    .grey {
      display: block;
    }

    .blue {
      display: none;
    }

    .active {
      color: $colorNormal;
      border-bottom: 2px solid $colorNormal;

      .grey {
        display: none;
      }

      .blue {
        display: block;
      }
    }

  }

}
</style>